import { useQueryClient } from '@tanstack/react-query';
import { TBillingSubscription, TSubscriptionsResponse } from '@onesource/schemas';

export const useGetMemberSubscriptionByNoQuery = (subscriptionNo: number | string) => {
  const queryClient = useQueryClient();

  const subscription = queryClient
    .getQueriesData<TSubscriptionsResponse>({ queryKey: ['billing', 'subscriptions'] })
    .reduce<TBillingSubscription[]>((acc, [, data]) => acc.concat(data?.items ?? []), [])
    .find(s => String(s.subscriptionNo) === String(subscriptionNo));

  return { data: subscription as TBillingSubscription | undefined };
};
